import http from 'hub-http/clients/apiClient';
import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import { getCMPBaseUrl } from '../utils/urls';
import { getEarlyRequesterResultPromise } from '../utils/getEarlyRequesterResultPromise';
export const fetchContentObject = (contentObjectType, contentId) => {
  const uri = getCMPBaseUrl(contentObjectType, contentId);
  return getEarlyRequesterResultPromise({
    name: 'fetch-content-object',
    retryRequest: () => http.get(uri, {
      query: {
        includeArchived: true
      }
    })
  });
};
export const fetchContentObjectByAnalyticsPageId = (contentObjectType, analyticsPageId) => {
  const uri = `/content-management/search/v1/${contentObjectType}`;
  return http.post(uri, {
    data: {
      count: 1,
      filterGroups: [{
        filters: [{
          property: CONTENT_PLATFORM_PROPERTY_NAME.ANALYTICS_PAGE_ID,
          operator: 'EQ',
          value: analyticsPageId
        }]
      }]
    }
  }).then(response => {
    if (response.results.length === 1) {
      return response.results[0];
    }
    throw new Error('No content object found');
  });
};